import * as angular from 'angular';

export class AncillariesCallPaymentsService {

    constructor (
        private AncillariesConstant:AncillariesConstant,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private AncillariesUtilsService: any,
        private AncillariesPaymentTransformer: any,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private CommonsGenericProxy: CommonsGenericProxy
    ) {}

    getPayments = (): angular.IPromise<any> => {
        const checkinId = this.localStorageService.get('flowId');
        return new Promise((resolve, reject) => {
            if (checkinId !== null) {
                const endpoint = this.AncillariesUtilsService.getEndpoint('pmt-ppm-rs') || this.AncillariesConstant.DEFAULT_ENDPOINTS.paymentsURI;
                const uri = endpoint + checkinId + '/payment-methods';
                this.CommonsGenericProxy.getGeneric(uri).then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                    });
            }
        });
    };

    updatePayments = (paymentData: any, paymentInfo: any, selectedLoggedCard: any): angular.IPromise<any> => {
        const paymentTransformed = this.AncillariesPaymentTransformer.createPaymentsRequest(paymentData, paymentInfo, selectedLoggedCard);
        const checkinId = this.localStorageService.get('flowId');
        const endpoint = this.AncillariesUtilsService.getEndpoint('ass-fass-rs') || this.AncillariesConstant.DEFAULT_ENDPOINTS.payAndIssueURI;
        const uri = endpoint + checkinId + '/ancillaries/pay-and-issue';
        const data: any = angular.toJson(paymentTransformed);
        return new Promise( (resolve, reject) => {
            this.CommonsGenericProxy.postGeneric(uri, data).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
        });
    };
}
AncillariesCallPaymentsService.$inject = ['AncillariesConstants', 'localStorageService', 'AncillariesUtilsService', 'AncillariesPaymentTransformer', 'CommonsNewHttpUtilsErrorService', 'CommonsGenericProxy'];
try {
    const mod = angular.module('ib-web-ancillaries-module');
    mod.service(
        'AncillariesCallPaymentsService',
        AncillariesCallPaymentsService
    );
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-module', []);
    mod.service(
        'AncillariesCallPaymentsService',
        AncillariesCallPaymentsService
    );
}